import s from './styles.module.scss'

export const Divider = () => <span className={s.divider} />
